<script setup lang="ts">
  import { inject } from 'vue'
  import FlowHeader from '@/shared/components/rebranding/FlowHeader/FlowHeader.vue'
  import { NeedHelpWidget } from '@/widgets'
  import {
    DEFAULT_FLOW_CURRENT_STEP,
    DEFAULT_FLOW_STEPS_COUNT,
  } from '@/shared/constants/flow.constants'
  import ProgressBarQC from '@qicgroupdoha/qic-connect-ds/components/ProgressBarQC'

  interface Props {
    withArrowBack?: boolean
    stepsCount?: number
    disableProgressBar?: boolean
  }
  interface Emits {
    (e: 'goBack'): void
  }

  interface Slots {
    'default'(): void
  }

  withDefaults(defineProps<Props>(), {
    withArrowBack: true,
    stepsCount: DEFAULT_FLOW_STEPS_COUNT,
    disableProgressBar: false,
  })
  const emit = defineEmits<Emits>()
  const currentStep = defineModel<number>('currentStep', { default: DEFAULT_FLOW_CURRENT_STEP })
  defineSlots<Slots>()

  const localeRTL = inject<LocaleType>('localeRTL')
</script>

<template>
  <section class="flow" :class="{ rtl: localeRTL }">
    <div class="flow__container">
      <div class="flow__header">
        <FlowHeader :with-arrow-back="withArrowBack" @back="emit('goBack')" />
        <div class="flow__progress-bar">
          <ProgressBarQC
            v-if="(stepsCount || currentStep) && !disableProgressBar"
            v-model="currentStep"
            :steps="stepsCount"
            data-test="progress-bar"
          />
        </div>
      </div>
      <slot />
      <NeedHelpWidget />
    </div>
  </section>
</template>

<style lang="scss" scoped>
  .flow {
    min-height: 100%;
    background-color: var(--colorBgSrfSecondary);
    padding-block: var(--spacing-7);
    display: flex;
    justify-content: center;
    align-items: stretch;
  }

  .flow__header {
    width: 100%;
    padding-bottom: var(--spacing-9);
  }

  .flow__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    min-width: 544px;
    margin: 0 auto;
  }

  .flow__progress-bar {
    margin: var(--spacing-3) var(--spacing-7);
  }

  @media (max-width: 544px) {
    .flow__container {
      min-width: 100%;
    }
  }

  @media (max-width: 768px) {
    .flow__header {
      padding-bottom: var(--spacing-7);
    }

    .flow__progress-bar {
      margin: var(--spacing-3) var(--spacing-5);
    }
  }
</style>
